import axios from '@dap/shared-utils/http.js';

export default {
    getCrowdsList (params) {
        return axios.get('/dapper/api/cro/crowds', { params });
    },

    // 推送
    pushcrowPackage (params) {
        return axios.post('/dapper/api/cro/push', params);
    },

    pushDetail (params) {
        return axios.get('/dapper/api/cro/push/detail', { params });
    },

    // 修改状态
    changeStatus (params) {
        return axios.put('/dapper/api/cro/status', params);
    },

    deleteCrowds (params) {
        return axios.put('/dapper/api/cro/delete', params);
    },

    getOperationRules (params) {
        return axios.get('/dapper/api/cro/operation/rules', { params });
    },

    getDetail (params) {
        return axios.get('/dapper/api/cro/detail', { params });
    },

    getDetailV2 (params) {
        return axios.get('/dapper/api/v2/cro/crowd', { params });
    },

    createCrows (params) {
        if (!params.crowd_id) {
            return axios.post('/dapper/api/cro/crowds', params, {
                headers: { 'Content-Type': 'application/json' },
            });
        }
        return axios.put('/dapper/api/cro/crowds', params, {
            headers: { 'Content-Type': 'application/json' },
        });
    },

    createCrowsV2 (params) {
        return axios.post('/dapper/api/v2/cro/crowd', params, {
            headers: { 'Content-Type': 'application/json' },
        });
    },

    getCopyCrows (params) {
        return axios.get('/dapper/api/cro/copy', { params });
    },

    getCopyCrowsV2 (params) {
        return axios.get('/dapper/api/v2/cro/crowd/copy', { params });
    },

    getDictInfo (params) {
        return axios.get('/dapper/api/aud/crowd/filter', { params });
    },

    checkdDuplicateName (params) {
        return axios.post('/dapper/api/aud/ver_name', params);
    },

    getRelationGroupList (params) {
        return axios.get('/dapper/api/cro/relation', { params });
    },

    getCrowdLogs (params) {
        return axios.get('/dapper/api/cro/logs', { params });
    },

    getAudienceSource (params) {
        return axios.get('/dapper/api/cro-like/sources', { params });
    },

    againPush (params) {
        return axios.put('/dapper/api/cro/fail_push', params);
    },

    creativeLikeCrowds (params) {
        if (params.crowd_id) {
            return axios.get('/dapper/api/cro-like/crowds', { params });
        }
        return axios.post('/dapper/api/cro-like/crowds', params);
    },

    getCountryRegions (params) {
        return axios.get('/dapper/api/cro/country-regions', { params });
    },

    searchCountryRegions (params) {
        return axios.get('/dapper/api/cro/country_region/search', { params });
    },

    updateCrowdVendor (params) {
        return axios.post('/dapper/api/cro/crowd/vendor', params);
    },

    getNewCrowdDict (params) {
        return axios.get('/dapper/api/cro/dict', { params });
    },

    getEffectivData (params) {
        return axios.get('/dapper/api/cro/effectiv_statuses', { params });
    },

    postCrowdVendor (params) {
        return axios.post('/dapper/api/cro/crowd/vendor', params);
    },

    getOplogsData (params) {
        return axios.get('/dapper/api/cro/oplogs', { params });
    },

    getCountryRegionList (params) {
        return axios.get('/dapper/api/cro/country_region/search', { params });
    },

    getAudienceSrcList (params) {
        return axios.get('/dapper/api/cro/source_crowds', { params });
    },

    getTagList (params) {
        return axios.get('/dapper/api/cro/tags', { params });
    },

    getTagDetail (params) {
        return axios.get('/dapper/api/cro/tag/detail', { params });
    },

    getEventList (params) {
        return axios.get('/dapper/api/v2/cro/norm/dict', { params });
    },

    getDeviceBrandList (params) {
        return axios.get('/dapper/api/v2/cro/device_brand', { params });
    },
    getMaterialDict (params) {
        return axios.get('/dapper/api/materiel_2/material-dict_v2', { params });
    },
    getMarketingTagTree (params) {
        return axios.get('/dapper/api/material/v2/marketing_tag/tree', { params });
    },
    getMarketingClassTree (params) {
        return axios.get('/dapper/api/material/v2/material_class/tree', { params });
    },
    getMaterialNameList (params) {
        return axios.get('/coach/api/materials', { params });
    },

    getAttrApreaderList (params) {
        return axios.get('/dapper/api/v2/cro/spreader_postion', { params });
    },

    downloadAttrApreader (params) {
        return axios.put('/dapper/api/v2/cro/download', params);
    },
};
